<template>
  <div v-show="editShow">
    <div class="container">
      <el-row :gutter="20">
        <div class="clearfix">
          <div class="crumbs">
            <i class="el-icon-back"></i>
            <el-button type="text" @click="goBack">返回</el-button>
          </div>
          <div class="btn-save">
            <el-button type="primary" @click="saveClick('ruleForm')">保存</el-button>
          </div>
        </div>
        <div class="form-box">
          <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" class="eidt-el-form">
            <!-- <UploadImg @uploadImg="getUploadImg" :editImg="editImg" :imgTitle="imgTitle"></UploadImg> -->
            <el-form-item label="姓名" prop="name">
              <el-input v-model="ruleForm.name" :disabled="disabled"></el-input>
            </el-form-item>
            <el-form-item label="手机号" prop="phone">
              <el-input v-model="ruleForm.phone" :disabled="disabled"></el-input>
            </el-form-item>
            <el-form-item label="票总数量" prop="total">
              <el-input v-model="ruleForm.total" min='0' type="number"></el-input>
            </el-form-item>
            <el-form-item label="票类型" prop="ticketTypeId">
              <el-select v-model="ruleForm.ticketTypeId" placeholder="选择票类型" :disabled="disabled">
                <el-option
                  v-for="(type,index) in TicketType"
                  :label="type.name"
                  :key="index"
                  :value="type.ticketTypeId">
                  <div @click="getChangeType(type)">{{type.name}}</div>
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="已使用数量" prop="useNumber" v-show="ticketCom_Id!=''">
              <el-input v-model="ruleForm.useNumber" min='0' type="number" :disabled="disabled"></el-input>
            </el-form-item>
          </el-form>
        </div>
      </el-row>
    </div>
  </div>
</template>

<script>
import UploadImg from './uploadImg/UploadImg'
import bus from '../../common/bus'
import checkPhone from "../../common/checkPhone";

export default {
  data() {
    return {
      rules: {
        name: [{ required: true, message: "请填写姓名", trigger: "blur" }],
        phone: [{ required: true, validator: checkPhone, trigger: "blur" }],
        ticketTypeId: [{ required: true, message: "票类型不能为空", trigger: "blur" }],
        total: [{ required: true, message: "数量不能为空", trigger: "blur" }]
      },
      ruleForm: {
        ticketTypeId:"",
        name: "",
        phone: "",
        total:"",
        typeName:"",
        projectId:localStorage.getItem('project_Id'),
        useNumber:0
      },
      editImg:"",
      ticketCom_Id: "",
      dataList:[],
      TicketType:[],
      imgTitle:'',
      disabled:false
    };
  },
  props: {
    editShow: {
      type: Boolean,
      default: false
    },
    arrarList: {
      type: Array,
      default() {
        return [];
      }
    },
    editData: {
      type: Object
    }
  },
  created(){ 
    this.getTicketType();
    
  },
  watch: {
    editData: function() {
      const item = this.editData;
      if(item){
      this.ruleForm = item?item:this.ruleForm;
      this.ticketCom_Id = item.ticketComplimentaryId
      this.disabled = true
      // this.editImg = item.avatar;
      }
    }
  },
  methods: {
    saveClick(ruleForm) {
      this.$refs[ruleForm].validate(valid => {
        if (valid) {   
          const loading =this.$loading({
              lock: true,
              text: 'Loading',
              spinner: 'el-icon-loading',
              background: 'rgba(0, 0, 0, 0.7)'
            });
          if (this.ticketCom_Id == '' || this.ticketCom_Id == undefined) {
            for (let i = 0; i < this.arrarList.length; i++) {
              let phone = this.arrarList[i].phone;
              if (phone == this.ruleForm.phone) {
                this.$message.error("该手机号已经存在");
                return false;
              }
            }
            this.$axios.post("/TicketComplimentary/", this.ruleForm).then(res => {
                loading.close();
              if (res.data.hasError == false) {
                this.$message.success("保存成功！");
                this.goBack();
              } else {
                this.$message.error(res.data.message);
              }
            });
          } else {
            this.$axios.patch("/TicketComplimentary/", this.ruleForm)
              .then(res => {
                loading.close();
                if (res.data.hasError == false) {
                  this.$message.success("编辑成功！");
                  this.goBack();
                  this.$refs[ruleForm].resetFields();
                } else {
                  this.$message.error(res.data.message);
                }
              });
          }
        } else {
          return false;
        }
      });
    },
    goBack() {
      this.editData = null;
      this.$emit("backFunStu");
      this.ticketCom_Id = '';
      this.disabled = false;
      this.ruleForm.useNumber=0;
      this.$refs['ruleForm'].resetFields();
    },
    /*getUploadImg(imgSrc){
      this.ruleForm.banner = imgSrc;
    },*/
    getTicketType(){
      this.$axios.get('/TicketType/Project/'+this.ruleForm.projectId).then(res =>{
        if (res.data.hasError == false) {
          this.TicketType = [...res.data.data]
        }
      })
    },
    getChangeType(type){
      this.ruleForm.ticketTypeId = type.ticketTypeId;
      this.ruleForm.typeName = type.name;
    }
  },
  components: {
    UploadImg
  }
};
</script>